<template>
  <div id="app">
    <router-view /> 
  </div>
</template>

<script> 

export default {
  name: "App",  
};
</script>

<style scoped>
@font-face {
  font-family: Alimama DaoLiTi;
  src: url('https://zhpoetry.oss-cn-hangzhou.aliyuncs.com/poetry/typeface/AlimamaDaoLiTi.ttf');
}

@font-face {
  font-family: Source Han Serif CN;
  src: url('https://zhpoetry.oss-cn-hangzhou.aliyuncs.com/poetry/typeface/SourceHanSerifCN-Medium.otf');
}
@font-face {
  font-family: DOUYU;
  src: url('https://zhpoetry.oss-cn-hangzhou.aliyuncs.com/poetry/typeface/douyuFont.otf');
}
</style>
